import type { LocationSnapshot } from "../types/location";

export type StoredUser = {
  id?: string;
  name?: string;
  email?: string;
  username?: string;
  role?: string;
  activePlanCode?: "free" | "pro" | "elite";
  planSelectionCompleted?: boolean;
  location?: string | null;
  profileLocation?: LocationSnapshot | null;
  browsingLocation?: LocationSnapshot | null;
  browsingRadiusMiles?: number | null;
  [key: string]: unknown;
};

export const setToken = (t: string): void => localStorage.setItem("token", t);
export const getToken = (): string | null => localStorage.getItem("token");
export const clearToken = (): void => localStorage.removeItem("token");
export const setRefreshToken = (t: string): void => localStorage.setItem("refreshToken", t);
export const getRefreshToken = (): string | null => localStorage.getItem("refreshToken");
export const clearRefreshToken = (): void => localStorage.removeItem("refreshToken");

export const setUser = (user: StoredUser): void =>
	localStorage.setItem("user", JSON.stringify(user));
export const getUser = (): StoredUser | null => {
	try {
		const raw = localStorage.getItem("user");
		return raw ? (JSON.parse(raw) as StoredUser) : null;
	} catch {
		return null;
	}
};
export const clearUser = (): void => localStorage.removeItem("user");

export const setRememberMe = (remember: boolean): void => {
	localStorage.setItem("rememberMe", remember ? "true" : "false");
};
export const getRememberMe = (): boolean => {
	return localStorage.getItem("rememberMe") === "true";
};

export const setSavedEmail = (email: string): void => {
	localStorage.setItem("savedEmail", email);
};
export const getSavedEmail = (): string => {
	return localStorage.getItem("savedEmail") || "";
};
export const clearSavedEmail = (): void => {
	localStorage.removeItem("savedEmail");
};

export const clearAuth = (): void => {
	clearToken();
	clearRefreshToken();
	clearUser();
	if (!getRememberMe()) {
		clearSavedEmail();
	}
};

export const isAuthed = (): boolean => !!getToken();
export const hasRole = (role: string): boolean => {
  const user = getUser();
  return typeof user?.role === "string" && user.role.toLowerCase() === role.toLowerCase();
};
